<!-- See public/logo.svg for source -->
<template>
    <svg viewBox="0 0 23.631 23.631" xmlns="http://www.w3.org/2000/svg" fill="var(--p-primary-color)">
        <polygon points="0,0.663 9.401,0.663 15.882,7.146 15.882,14.127 5.307,3.608 5.274,22.969 0,22.969" />
        <polygon points="23.631,22.969 14.232,22.969 7.752,16.485 7.752,9.501 18.327,20.018 18.359,0.662 23.631,0.662" />
    </svg>
</template>
